(function () {
  function numberFrom(tier, keys, fallback) {
    for (var index = 0; index < keys.length; index += 1) {
      if (tier && tier[keys[index]] != null && Number.isFinite(Number(tier[keys[index]]))) {
        return Number(tier[keys[index]]);
      }
    }
    return fallback;
  }

  function normalizeTiers(tiers) {
    var byMinimum = {};

    (Array.isArray(tiers) ? tiers : []).forEach(function (tier) {
      var minimum = Math.max(1, Math.floor(numberFrom(tier, [
        'minQty', 'min_qty', 'minimumQuantity', 'minimum_quantity', 'quantity', 'min'
      ], 0)));
      var discount = numberFrom(tier, ['discountPercent', 'discount_percent', 'percent'], NaN);

      if (!Number.isFinite(discount)) {
        var multiplier = numberFrom(tier, ['multiplier', 'coefficient', 'coef'], NaN);
        if (Number.isFinite(multiplier)) discount = (1 - multiplier) * 100;
      }

      discount = Math.max(0, Math.min(100, Number(discount) || 0));
      if (!minimum || !discount) return;
      byMinimum[minimum] = Math.max(byMinimum[minimum] || 0, discount);
    });

    return Object.keys(byMinimum).map(function (minimum) {
      return { minimum: Number(minimum), discount: byMinimum[minimum] };
    }).sort(function (left, right) {
      return left.minimum - right.minimum;
    });
  }

  function percentLabel(value) {
    return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
      maximumFractionDigits: 2
    }).format(value);
  }

  function moneyLabel(cents, currency, suffix) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency: currency
      }).format(cents / 100) + suffix;
    } catch (_error) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €' + suffix;
    }
  }

  function updateDisplayedPrice(productInfo, quantity, activeTier, tiers) {
    var priceNode = productInfo && productInfo.querySelector('[data-orion-proxy-from-price]');
    var basePriceNode = productInfo && productInfo.querySelector('[data-orion-textile-base-price]');
    var discountBadge = productInfo && productInfo.querySelector('[data-orion-textile-discount-badge]');
    if (!priceNode || !window.OrionDiscountConfig) return;

    var baseCents = Math.max(0, Number(priceNode.dataset.basePriceCents) || 0);
    var nativeCents = Math.max(0, Number(priceNode.dataset.nativeLowestCents) || baseCents);
    var cents = quantity > 0
      ? Math.round(baseCents * (1 - (activeTier ? activeTier.discount : 0) / 100))
      : window.OrionDiscountConfig.lowestPriceCents(baseCents, nativeCents, tiers.map(function (tier) {
          return { discountPercent: tier.discount };
        }));
    var currency = priceNode.dataset.currency || 'EUR';
    var suffix = priceNode.dataset.priceSuffix || '';
    var hasActiveDiscount = quantity > 0 && activeTier && activeTier.discount > 0;

    priceNode.dataset.orionPriceHtCents = String(cents);
    priceNode.removeAttribute('data-orion-price-pending');
    priceNode.textContent = moneyLabel(cents, currency, suffix);
    if (basePriceNode) {
      basePriceNode.hidden = !hasActiveDiscount;
      basePriceNode.dataset.orionPriceHtCents = String(baseCents);
      basePriceNode.textContent = moneyLabel(baseCents, currency, suffix);
    }
    if (discountBadge) {
      discountBadge.hidden = !hasActiveDiscount;
      discountBadge.textContent = hasActiveDiscount ? '-' + percentLabel(activeTier.discount) + '%' : '';
    }
    if (window.OrionPriceDisplay && typeof window.OrionPriceDisplay.refresh === 'function') {
      window.OrionPriceDisplay.refresh(productInfo);
    }
  }

  function getSelectedVariant(productInfo) {
    var selectedVariantNode = productInfo && productInfo.querySelector('variant-selects [data-selected-variant]');
    if (!selectedVariantNode) return null;
    try {
      return JSON.parse(selectedVariantNode.textContent || 'null');
    } catch (_error) {
      return null;
    }
  }

  function isVariantAvailable(variant) {
    if (!variant || variant.available === false) return false;

    var minimumQuantity = Math.max(1, Math.floor(Number(variant.quantity_rule && variant.quantity_rule.min) || 1));
    var inventoryQuantity = Number(variant.inventory_quantity);
    var inventoryIsManaged = variant.inventory_management === 'shopify'
      && String(variant.inventory_policy || '').toLowerCase() !== 'continue';

    return !(inventoryIsManaged && Number.isFinite(inventoryQuantity) && minimumQuantity > inventoryQuantity);
  }

  function updateAddToCartButton(productInfo, hasQuantity, variant) {
    var submitButton = productInfo && productInfo.querySelector('product-form [name="add"]');
    var variantInput = productInfo && productInfo.querySelector('product-form .product-variant-id');
    if (!submitButton) return;

    var selectedVariant = variant || getSelectedVariant(productInfo);
    var available = isVariantAvailable(selectedVariant);
    var canAddToCart = available && hasQuantity;
    var buttonLabel = submitButton.querySelector('span');

    submitButton.classList.toggle('orion-quantity-missing', available && !hasQuantity);
    submitButton.disabled = !canAddToCart;
    submitButton.setAttribute('aria-disabled', canAddToCart ? 'false' : 'true');
    if (variantInput) variantInput.disabled = !available;
    if (buttonLabel) {
      buttonLabel.textContent = !selectedVariant
        ? window.variantStrings.unavailable
        : (available ? window.variantStrings.addToCart : window.variantStrings.soldOut);
    }
  }

  function render(wrapper, tiers) {
    var quantityForm = wrapper.closest('.product-form__quantity');
    var input = quantityForm && quantityForm.querySelector('.quantity__input');
    var status = wrapper.querySelector('[data-orion-textile-tier-status]');
    var list = wrapper.querySelector('[data-orion-textile-tier-list]');
    var productInfo = wrapper.closest('product-info');
    var fromPrefix = productInfo && productInfo.querySelector('[data-orion-textile-from-prefix]');
    var hasTiers = tiers.length > 0;

    wrapper.hidden = !hasTiers;
    if (fromPrefix) fromPrefix.hidden = !hasTiers;
    if (!input || !status || !list) {
      if (wrapper._orionQuantityInput && wrapper._orionQuantityRefresh) {
        wrapper._orionQuantityInput.removeEventListener('change', wrapper._orionQuantityRefresh);
        wrapper._orionQuantityInput.removeEventListener('input', wrapper._orionQuantityRefresh);
      }
      wrapper._orionQuantityInput = null;
      wrapper._orionQuantityRefresh = null;
      if (list) list.replaceChildren();
      return;
    }

    list.replaceChildren();
    tiers.forEach(function (tier) {
      var item = document.createElement('li');
      item.textContent = 'À partir de ' + tier.minimum + ' article' + (tier.minimum > 1 ? 's' : '') +
        ' : -' + percentLabel(tier.discount) + ' %';
      list.appendChild(item);
    });

    function refresh() {
      var hasQuantity = String(input.value || '').trim() !== '' && Number(input.value) > 0;
      var quantity = hasQuantity ? Math.max(1, Math.floor(Number(input.value))) : 0;
      var nextTier = tiers.find(function (tier) { return tier.minimum > quantity; });
      var activeTier = tiers.slice().reverse().find(function (tier) { return tier.minimum <= quantity; });

      if (fromPrefix) fromPrefix.hidden = !hasTiers || hasQuantity;
      updateAddToCartButton(productInfo, hasQuantity, wrapper._orionCurrentVariant);

      if (!hasQuantity) {
        status.textContent = 'Saisissez une quantité pour connaître votre prix et votre prochain palier.';
      } else if (nextTier) {
        var missing = nextTier.minimum - quantity;
        status.textContent = 'Plus que ' + missing + ' article' + (missing > 1 ? 's' : '') +
          ' pour obtenir une remise de ' + percentLabel(nextTier.discount) + ' %.';
      } else if (activeTier) {
        status.textContent = 'Vous bénéficiez de la remise maximale de ' + percentLabel(activeTier.discount) + ' %.';
      } else {
        status.textContent = 'Ajoutez des articles pour bénéficier de remises sur la quantité.';
      }
      updateDisplayedPrice(productInfo, quantity, activeTier, tiers);
    }

    if (wrapper._orionQuantityInput && wrapper._orionQuantityRefresh) {
      wrapper._orionQuantityInput.removeEventListener('change', wrapper._orionQuantityRefresh);
      wrapper._orionQuantityInput.removeEventListener('input', wrapper._orionQuantityRefresh);
    }
    wrapper._orionQuantityInput = input;
    wrapper._orionQuantityRefresh = refresh;
    input.addEventListener('change', refresh);
    input.addEventListener('input', refresh);
    refresh();
  }

  function initialize(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var wrappers = Array.prototype.slice.call(scope.querySelectorAll('[data-orion-textile-tier-info]'));
    if (scope.matches && scope.matches('[data-orion-textile-tier-info]')) wrappers.unshift(scope);
    if (!wrappers.length || !window.OrionDiscountConfig) return;

    window.OrionDiscountConfig.load().then(function (config) {
      wrappers.forEach(function (wrapper) {
        var product = window.OrionDiscountConfig.resolveProduct(config, {
          id: wrapper.dataset.productId,
          handle: wrapper.dataset.productHandle
        });
        render(wrapper, normalizeTiers(product && product.tiers));
      });
    });
  }

  function subscribeToVariantChanges() {
    if (window.orionTextileVariantChangeUnsubscriber || typeof subscribe !== 'function'
      || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.variantChange) return;

    window.orionTextileVariantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data || !data.sectionId) return;

      var submitButton = document.getElementById('ProductSubmitButton-' + data.sectionId);
      var productInfo = submitButton && submitButton.closest('product-info');
      var wrapper = productInfo && productInfo.querySelector('[data-orion-textile-tier-info]');
      if (wrapper && wrapper._orionQuantityRefresh) {
        wrapper._orionCurrentVariant = data.variant || getSelectedVariant(productInfo);
        wrapper._orionQuantityRefresh();
      }
    });
  }

  subscribeToVariantChanges();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  document.addEventListener('orion:discount-prices-hydrated', function () { initialize(document); });
})();
